export const adminToolPaths = {
  root: '/admin-tool',
  users: {
    root: '/admin-tool/users',
    newUser: '/admin-tool/users/new-user',
    detail: '/admin-tool/users/:userId'
  },
  turbines: {
    root: '/admin-tool/turbines',
    newTurbine: '/admin-tool/turbines/new-turbine',
    detail: '/admin-tool/turbines/:turbineId'
  },
  locations: {
    root: '/admin-tool/locations',
    newLocation: '/admin-tool/locations/new-location',
    detail: '/admin-tool/locations/:locationId'
  },
  companies: {
    root: '/admin-tool/companies',
    newCompany: '/admin-tool/companies/new-company',
    detail: '/admin-tool/companies/:companyId'
  }
};

export const adminToolTabs = [
  { id: 'users', label: 'Users', path: adminToolPaths.users.root },
  { id: 'turbines', label: 'Turbines', path: adminToolPaths.turbines.root },
  { id: 'locations', label: 'Locations', path: adminToolPaths.locations.root },
  { id: 'companies', label: 'Companies', path: adminToolPaths.companies.root }
];

export const pathNames = [
  {
    name: 'New User',
    path: adminToolPaths.users.newUser
  },
  {
    name: 'New Turbine',
    path: adminToolPaths.turbines.newTurbine
  },
  {
    name: 'New Location',
    path: adminToolPaths.locations.newLocation
  },
  {
    name: 'New Company',
    path: adminToolPaths.companies.newCompany
  }
];
